"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryClientImpl = exports.Address = exports.QueryModuleAddressResponse = exports.QueryModuleAddressRequest = exports.QueryAllModuleAddressResponse_AddressesEntry = exports.QueryAllModuleAddressResponse = exports.QueryAllModuleAddressRequest = exports.QueryAllBlockResponse = exports.QueryAllBlockRequest = exports.QueryAllTransactionResponse = exports.QueryAllTransactionRequest = exports.QueryAllMessageTypeResponse = exports.QueryAllMessageTypeRequest = exports.QuerySearchResponse = exports.QuerySearchRequest = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const pagination_1 = require("../cosmos/base/query/v1beta1/pagination");
const transaction_1 = require("./transaction");
const order_1 = require("../order/order");
const block_1 = require("./block");
const message_type_1 = require("./message_type");
exports.protobufPackage = "Switcheo.carbon.misc";
const baseQuerySearchRequest = { keyword: "" };
exports.QuerySearchRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.keyword !== "") {
            writer.uint32(10).string(message.keyword);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQuerySearchRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.keyword = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQuerySearchRequest);
        message.keyword =
            object.keyword !== undefined && object.keyword !== null
                ? String(object.keyword)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.keyword !== undefined && (obj.keyword = message.keyword);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQuerySearchRequest);
        message.keyword = (_a = object.keyword) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseQuerySearchResponse = { messageTypes: "" };
exports.QuerySearchResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.transactions) {
            transaction_1.Transaction.encode(v, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.orders) {
            order_1.Order.encode(v, writer.uint32(18).fork()).ldelim();
        }
        for (const v of message.messageTypes) {
            writer.uint32(26).string(v);
        }
        for (const v of message.blocks) {
            block_1.Block.encode(v, writer.uint32(34).fork()).ldelim();
        }
        for (const v of message.addresses) {
            exports.Address.encode(v, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQuerySearchResponse);
        message.transactions = [];
        message.orders = [];
        message.messageTypes = [];
        message.blocks = [];
        message.addresses = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.transactions.push(transaction_1.Transaction.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.orders.push(order_1.Order.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.messageTypes.push(reader.string());
                    break;
                case 4:
                    message.blocks.push(block_1.Block.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.addresses.push(exports.Address.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a, _b, _c, _d, _e;
        const message = Object.assign({}, baseQuerySearchResponse);
        message.transactions = ((_a = object.transactions) !== null && _a !== void 0 ? _a : []).map((e) => transaction_1.Transaction.fromJSON(e));
        message.orders = ((_b = object.orders) !== null && _b !== void 0 ? _b : []).map((e) => order_1.Order.fromJSON(e));
        message.messageTypes = ((_c = object.messageTypes) !== null && _c !== void 0 ? _c : []).map((e) => String(e));
        message.blocks = ((_d = object.blocks) !== null && _d !== void 0 ? _d : []).map((e) => block_1.Block.fromJSON(e));
        message.addresses = ((_e = object.addresses) !== null && _e !== void 0 ? _e : []).map((e) => exports.Address.fromJSON(e));
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.transactions) {
            obj.transactions = message.transactions.map((e) => e ? transaction_1.Transaction.toJSON(e) : undefined);
        }
        else {
            obj.transactions = [];
        }
        if (message.orders) {
            obj.orders = message.orders.map((e) => (e ? order_1.Order.toJSON(e) : undefined));
        }
        else {
            obj.orders = [];
        }
        if (message.messageTypes) {
            obj.messageTypes = message.messageTypes.map((e) => e);
        }
        else {
            obj.messageTypes = [];
        }
        if (message.blocks) {
            obj.blocks = message.blocks.map((e) => (e ? block_1.Block.toJSON(e) : undefined));
        }
        else {
            obj.blocks = [];
        }
        if (message.addresses) {
            obj.addresses = message.addresses.map((e) => e ? exports.Address.toJSON(e) : undefined);
        }
        else {
            obj.addresses = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = Object.assign({}, baseQuerySearchResponse);
        message.transactions = ((_a = object.transactions) !== null && _a !== void 0 ? _a : []).map((e) => transaction_1.Transaction.fromPartial(e));
        message.orders = ((_b = object.orders) !== null && _b !== void 0 ? _b : []).map((e) => order_1.Order.fromPartial(e));
        message.messageTypes = ((_c = object.messageTypes) !== null && _c !== void 0 ? _c : []).map((e) => e);
        message.blocks = ((_d = object.blocks) !== null && _d !== void 0 ? _d : []).map((e) => block_1.Block.fromPartial(e));
        message.addresses = ((_e = object.addresses) !== null && _e !== void 0 ? _e : []).map((e) => exports.Address.fromPartial(e));
        return message;
    },
};
const baseQueryAllMessageTypeRequest = {};
exports.QueryAllMessageTypeRequest = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllMessageTypeRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseQueryAllMessageTypeRequest);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseQueryAllMessageTypeRequest);
        return message;
    },
};
const baseQueryAllMessageTypeResponse = {};
exports.QueryAllMessageTypeResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.messageTypes) {
            message_type_1.MessageType.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllMessageTypeResponse);
        message.messageTypes = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.messageTypes.push(message_type_1.MessageType.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllMessageTypeResponse);
        message.messageTypes = ((_a = object.messageTypes) !== null && _a !== void 0 ? _a : []).map((e) => message_type_1.MessageType.fromJSON(e));
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.messageTypes) {
            obj.messageTypes = message.messageTypes.map((e) => e ? message_type_1.MessageType.toJSON(e) : undefined);
        }
        else {
            obj.messageTypes = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllMessageTypeResponse);
        message.messageTypes = ((_a = object.messageTypes) !== null && _a !== void 0 ? _a : []).map((e) => message_type_1.MessageType.fromPartial(e));
        return message;
    },
};
const baseQueryAllTransactionRequest = {
    hash: "",
    address: "",
    msgTypeFilters: "",
};
exports.QueryAllTransactionRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.hash !== "") {
            writer.uint32(10).string(message.hash);
        }
        if (message.address !== "") {
            writer.uint32(18).string(message.address);
        }
        for (const v of message.msgTypeFilters) {
            writer.uint32(26).string(v);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllTransactionRequest);
        message.msgTypeFilters = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.hash = reader.string();
                    break;
                case 2:
                    message.address = reader.string();
                    break;
                case 3:
                    message.msgTypeFilters.push(reader.string());
                    break;
                case 4:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllTransactionRequest);
        message.hash =
            object.hash !== undefined && object.hash !== null
                ? String(object.hash)
                : "";
        message.address =
            object.address !== undefined && object.address !== null
                ? String(object.address)
                : "";
        message.msgTypeFilters = ((_a = object.msgTypeFilters) !== null && _a !== void 0 ? _a : []).map((e) => String(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = message.hash);
        message.address !== undefined && (obj.address = message.address);
        if (message.msgTypeFilters) {
            obj.msgTypeFilters = message.msgTypeFilters.map((e) => e);
        }
        else {
            obj.msgTypeFilters = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = Object.assign({}, baseQueryAllTransactionRequest);
        message.hash = (_a = object.hash) !== null && _a !== void 0 ? _a : "";
        message.address = (_b = object.address) !== null && _b !== void 0 ? _b : "";
        message.msgTypeFilters = ((_c = object.msgTypeFilters) !== null && _c !== void 0 ? _c : []).map((e) => e);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryAllTransactionResponse = {};
exports.QueryAllTransactionResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.transactions) {
            transaction_1.Transaction.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllTransactionResponse);
        message.transactions = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.transactions.push(transaction_1.Transaction.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllTransactionResponse);
        message.transactions = ((_a = object.transactions) !== null && _a !== void 0 ? _a : []).map((e) => transaction_1.Transaction.fromJSON(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.transactions) {
            obj.transactions = message.transactions.map((e) => e ? transaction_1.Transaction.toJSON(e) : undefined);
        }
        else {
            obj.transactions = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllTransactionResponse);
        message.transactions = ((_a = object.transactions) !== null && _a !== void 0 ? _a : []).map((e) => transaction_1.Transaction.fromPartial(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryAllBlockRequest = {};
exports.QueryAllBlockRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllBlockRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllBlockRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllBlockRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryAllBlockResponse = {};
exports.QueryAllBlockResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.blocks) {
            block_1.Block.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllBlockResponse);
        message.blocks = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.blocks.push(block_1.Block.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllBlockResponse);
        message.blocks = ((_a = object.blocks) !== null && _a !== void 0 ? _a : []).map((e) => block_1.Block.fromJSON(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.blocks) {
            obj.blocks = message.blocks.map((e) => (e ? block_1.Block.toJSON(e) : undefined));
        }
        else {
            obj.blocks = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllBlockResponse);
        message.blocks = ((_a = object.blocks) !== null && _a !== void 0 ? _a : []).map((e) => block_1.Block.fromPartial(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryAllModuleAddressRequest = {};
exports.QueryAllModuleAddressRequest = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllModuleAddressRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseQueryAllModuleAddressRequest);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseQueryAllModuleAddressRequest);
        return message;
    },
};
const baseQueryAllModuleAddressResponse = {};
exports.QueryAllModuleAddressResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        Object.entries(message.addresses).forEach(([key, value]) => {
            exports.QueryAllModuleAddressResponse_AddressesEntry.encode({ key: key, value }, writer.uint32(10).fork()).ldelim();
        });
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllModuleAddressResponse);
        message.addresses = {};
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    const entry1 = exports.QueryAllModuleAddressResponse_AddressesEntry.decode(reader, reader.uint32());
                    if (entry1.value !== undefined) {
                        message.addresses[entry1.key] = entry1.value;
                    }
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllModuleAddressResponse);
        message.addresses = Object.entries((_a = object.addresses) !== null && _a !== void 0 ? _a : {}).reduce((acc, [key, value]) => {
            acc[key] = String(value);
            return acc;
        }, {});
        return message;
    },
    toJSON(message) {
        const obj = {};
        obj.addresses = {};
        if (message.addresses) {
            Object.entries(message.addresses).forEach(([k, v]) => {
                obj.addresses[k] = v;
            });
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllModuleAddressResponse);
        message.addresses = Object.entries((_a = object.addresses) !== null && _a !== void 0 ? _a : {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = String(value);
            }
            return acc;
        }, {});
        return message;
    },
};
const baseQueryAllModuleAddressResponse_AddressesEntry = {
    key: "",
    value: "",
};
exports.QueryAllModuleAddressResponse_AddressesEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== "") {
            writer.uint32(18).string(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllModuleAddressResponse_AddressesEntry);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.value = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllModuleAddressResponse_AddressesEntry);
        message.key =
            object.key !== undefined && object.key !== null ? String(object.key) : "";
        message.value =
            object.value !== undefined && object.value !== null
                ? String(object.value)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.key !== undefined && (obj.key = message.key);
        message.value !== undefined && (obj.value = message.value);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseQueryAllModuleAddressResponse_AddressesEntry);
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : "";
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseQueryModuleAddressRequest = { module: "" };
exports.QueryModuleAddressRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.module !== "") {
            writer.uint32(10).string(message.module);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryModuleAddressRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.module = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryModuleAddressRequest);
        message.module =
            object.module !== undefined && object.module !== null
                ? String(object.module)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.module !== undefined && (obj.module = message.module);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryModuleAddressRequest);
        message.module = (_a = object.module) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseQueryModuleAddressResponse = { address: "" };
exports.QueryModuleAddressResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryModuleAddressResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryModuleAddressResponse);
        message.address =
            object.address !== undefined && object.address !== null
                ? String(object.address)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryModuleAddressResponse);
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseAddress = { name: "", address: "", type: "" };
exports.Address = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.name !== "") {
            writer.uint32(10).string(message.name);
        }
        if (message.address !== "") {
            writer.uint32(18).string(message.address);
        }
        if (message.type !== "") {
            writer.uint32(26).string(message.type);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseAddress);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.name = reader.string();
                    break;
                case 2:
                    message.address = reader.string();
                    break;
                case 3:
                    message.type = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseAddress);
        message.name =
            object.name !== undefined && object.name !== null
                ? String(object.name)
                : "";
        message.address =
            object.address !== undefined && object.address !== null
                ? String(object.address)
                : "";
        message.type =
            object.type !== undefined && object.type !== null
                ? String(object.type)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.name !== undefined && (obj.name = message.name);
        message.address !== undefined && (obj.address = message.address);
        message.type !== undefined && (obj.type = message.type);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = Object.assign({}, baseAddress);
        message.name = (_a = object.name) !== null && _a !== void 0 ? _a : "";
        message.address = (_b = object.address) !== null && _b !== void 0 ? _b : "";
        message.type = (_c = object.type) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
class QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.Search = this.Search.bind(this);
        this.MessageTypeAll = this.MessageTypeAll.bind(this);
        this.TransactionAll = this.TransactionAll.bind(this);
        this.BlockAll = this.BlockAll.bind(this);
        this.ModuleAddressAll = this.ModuleAddressAll.bind(this);
        this.ModuleAddress = this.ModuleAddress.bind(this);
    }
    Search(request) {
        const data = exports.QuerySearchRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.misc.Query", "Search", data);
        return promise.then((data) => exports.QuerySearchResponse.decode(new minimal_1.default.Reader(data)));
    }
    MessageTypeAll(request) {
        const data = exports.QueryAllMessageTypeRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.misc.Query", "MessageTypeAll", data);
        return promise.then((data) => exports.QueryAllMessageTypeResponse.decode(new minimal_1.default.Reader(data)));
    }
    TransactionAll(request) {
        const data = exports.QueryAllTransactionRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.misc.Query", "TransactionAll", data);
        return promise.then((data) => exports.QueryAllTransactionResponse.decode(new minimal_1.default.Reader(data)));
    }
    BlockAll(request) {
        const data = exports.QueryAllBlockRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.misc.Query", "BlockAll", data);
        return promise.then((data) => exports.QueryAllBlockResponse.decode(new minimal_1.default.Reader(data)));
    }
    ModuleAddressAll(request) {
        const data = exports.QueryAllModuleAddressRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.misc.Query", "ModuleAddressAll", data);
        return promise.then((data) => exports.QueryAllModuleAddressResponse.decode(new minimal_1.default.Reader(data)));
    }
    ModuleAddress(request) {
        const data = exports.QueryModuleAddressRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.misc.Query", "ModuleAddress", data);
        return promise.then((data) => exports.QueryModuleAddressResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.QueryClientImpl = QueryClientImpl;
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
